import { makeAutoObservable } from 'mobx'
import ApisauceDataStore from 'src/packages/fetchx/ApisauceDataStore'
import { apiSauceInstance } from 'src/services/api'
import { CenarioDetail } from '../types'

class CenariosStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  cenarios = new ApisauceDataStore<CenarioDetail>(apiSauceInstance, {
    useNodes: true,
    path: '/cenarios',
    resultsField: 'edges',
    countField: 'totalCount'
  })
}

export const cenariosStore = new CenariosStore()
export default CenariosStore
